import React, { useEffect, useRef } from 'react';
import Icon from '../../../../generic-components/Icon';
import close from '../../../../assets/svg/x-icon.svg';
import sww from '../../../../assets/svg/somethingWentWrongSign.svg';
import scs from '../../../../assets/icons/svg/colored-icons/ic-colored-success.svg';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';
import CheckSignLottie from '../../../../assets/lotties/checkmark_success_animation.json';
import Lottie from '../../../../generic-components/Lottie';

interface IProps {
  handleTryAgain?: () => void;
  handleClose: () => void;
  messageText: string;
  iconSource?: string;
  autoCloseTimeout?: number;
  needSpinner?: boolean;
  processingText?: string;
  useLottie?: boolean;
}

const UpperMessagePopUp = ({
  handleClose, handleTryAgain, messageText, iconSource, autoCloseTimeout, needSpinner, processingText, useLottie,
}:IProps) => {
  const startTime = Date.now();
  const intervalRef = useRef<any>();

  const checkTimeElapsed = () => {
    if (!autoCloseTimeout) return;
    const elapsedTime = (Date.now() - startTime) / 1000;
    if (elapsedTime >= autoCloseTimeout / 1000) {
      clearInterval(intervalRef.current);
      handleClose();
    }
  };

  const clear = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const initInterval = () => {
    if (!autoCloseTimeout) return;
    intervalRef.current = setInterval(() => {
      checkTimeElapsed();
    }, 1000);
  };

  useEffect(() => {
    clear();
    initInterval();
    return () => {
      clear();
    };
  });

  return (
    <div className='fixed top-0 z-[999] left-1/2 w-[55.875rem] h-[3.125rem] bg-bw03 rounded-b-lg -translate-x-1/2 flex justify-center items-center font-medium text-base text-bw08'>
      {!needSpinner ? (
        <>
          {useLottie && <Lottie lottieAsset={CheckSignLottie} isLoop={false} isAutoplay className='w-[1.5rem] h-[1.5rem] mr-2' />}
          { iconSource !== '' && <Icon iconId='upper-message' src={handleTryAgain ? sww : (iconSource ?? scs)} className='w-[1.5rem] h-[1.5rem] mr-2' />}
          <span className='text-base font-metricMedium text-bw08' id='upperMessageContent'>{messageText}</span>
          {handleTryAgain && (
          <span
            className='pl-2 underline underline-offset-4'
            tabIndex={0}
            role='button'
            onKeyDown={() => {
            }}
            onClick={handleTryAgain}
            id='upperMessageTryAgain'
          >
            Try again
          </span>
          )}
          <button
            id='upperMessageCloseBtn'
            className='absolute w-[1.5rem] h-[1.5rem] right-[0.813rem] top-[0.813rem] flex justify-center items-center'
            type='button'
            aria-label='Save'
            onClick={handleClose}
          >
            <Icon className='w-[0.625rem] h-[0.625rem]' src={close} />
          </button>
        </>
      ) : (
        <div className='flex items-center justify-center flex-row-reverse'>
          <p className='font-medium text-base text-bw08 ml-4'>{processingText ?? 'Processing'}</p>
          <Spinner
            containerClassName='!w-[24px] !h-[24px]'
            spinnerColor={SpinnerColor.Blue}
            height='24px'
            width='24px'
          />
        </div>
      )}
    </div>
  );
};

export default UpperMessagePopUp;
